import {
  TextField,
  Button,
  Box,
  CircularProgress,
} from "@mui/material";
import { useState, useEffect } from "react";
import SendIcon from '@mui/icons-material/Send';
import ContextoValidation from "../../utils/contextoValidation";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { getReadonlyFlag } from "../../utils/getRoleToken";

const ContextoInstitucional = ({
  nomeContexto = '',
  conteudoContexto = null,
  setDeveUpdateContexto = () => { },
  produto = 'AC',
  nomeExibicao = 'Informações adicionais' // Nova prop com valor padrão
}) => {
  const [contexto, setContexto] = useState(conteudoContexto || "");
  const [contextoOriginal, setContextoOriginal] = useState(conteudoContexto || "");
  const [validationModalOpen, setValidationModalOpen] = useState(false);

  const [isLoading, setIsLoading] = useState(true);
  const [, setErro401] = useState(false);

  const readonly = getReadonlyFlag();

  // Atualiza o contexto original quando conteudoContexto mudar
  useEffect(() => {
    setContexto(conteudoContexto || "");
    setContextoOriginal(conteudoContexto || "");
  }, [conteudoContexto]);

  // Verifica se houve alterações
  const hasChanges = contexto !== contextoOriginal;

  // Verifica se deve habilitar o botão
  const shouldEnableButton = () => {
    // Verifica se o contexto atual tem conteúdo
    const hasContent = contexto.length > 0;

    // Se não há conteúdo original, só habilita se tem texto
    if (!contextoOriginal) {
      return hasContent;
    }

    // Se há conteúdo original, só habilita se houve mudanças E tem conteúdo
    return hasChanges && hasContent;
  };

  const handleEnviarContexto = () => {
    // Abre o modal de validação
    setValidationModalOpen(true);
  };

  const handleConfirmContexto = async (dadosAlteracao) => {
    try {
      console.log('Contexto confirmado:', dadosAlteracao);

      // Atualiza o contexto original com o novo valor
      setContextoOriginal(contexto);

    } catch (error) {
      console.error("Erro ao processar confirmação:", error);
    }
  };

  // Função para resetar alterações (opcional)
  const handleResetChanges = () => {
    setContexto(contextoOriginal);
  };

  useEffect(() => {
    const fetchContextoInstitucional = async () => {
      setIsLoading(true);
      try {
        const token = localStorage.getItem('jwtToken');
        if (!token) {
          console.error("Token não encontrado no localStorage.");
          return;
        }

        const decodedToken = jwtDecode(token);
        const idClienteAipim = decodedToken.id_cliente;
        const baseURL = process.env.REACT_APP_API_BASE_URL;

        const response = await axios.get(`${baseURL}/produto/${produto}/contexto-institucional`, {
          params: {
            idClienteAipim: idClienteAipim
          },
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        const contextoData = response.data.length > 0
          ? (response.data[0]?.contextoInstitucional || response.data[0]?.ConteudoInstitucional || '')
          : '';

        console.log(contextoData)
        setContexto(contextoData);
        setContextoOriginal(contextoData);

      } catch (error) {
        console.error("Erro ao buscar Informações Institucionais:", error);

        // Adicione esta validação
        if (error.response && error.response.status === 401) {
          setErro401(true);
        }
      } finally {
        setIsLoading(false);
      }
    };

    fetchContextoInstitucional();
  }, [produto]);

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 400 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <TextField
        multiline
        rows={20}
        value={contexto}
        onChange={(e) => setContexto(e.target.value)}
        variant="outlined"
        fullWidth
        placeholder="Digite as informações específicas deste produto..."
        disabled={readonly}
        sx={{
          mb: 2,
          '& .MuiOutlinedInput-root': {
            bgcolor: 'background.paper',
            color: 'text.primary',
            borderRadius: 1.5,
            '& fieldset': {
              borderColor: 'divider',
            },
            ...(!readonly && {
              '&:hover fieldset': {
                borderColor: '#667eea',
              },
            }),
            '&.Mui-focused fieldset': {
              borderColor: '#667eea',
            },
          },
          '& .MuiInputLabel-root.Mui-focused': {
            color: '#667eea',
          },
          '& .MuiInputBase-input': {
            color: 'text.primary',
          },
        }}
      />

      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
        {hasChanges && !readonly && (
          <Button
            variant="outlined"
            onClick={handleResetChanges}
            sx={{
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600,
              px: 3,
              py: 1,
            }}
          >
            Desfazer
          </Button>
        )}

        {!readonly && (
          <Button
            variant="contained"
            endIcon={<SendIcon />}
            onClick={handleEnviarContexto}
            disabled={!shouldEnableButton()}
            sx={{
              backgroundColor: '#1976d2',
              '&:hover': {
                backgroundColor: '#1565c0',
              },
              '&:disabled': {
                backgroundColor: '#e0e0e0',
                color: '#9e9e9e',
              },
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600,
              px: 3,
              py: 1,
            }}
          >
            {contextoOriginal ? "Atualizar" : "Enviar"}
          </Button>
        )}
      </Box>

      <ContextoValidation
        open={validationModalOpen}
        onClose={() => setValidationModalOpen(false)}
        nomeContexto={nomeContexto}
        contexto={contexto}
        onConfirm={handleConfirmContexto}
        produto={produto}
      />
    </>
  );
};

export default ContextoInstitucional;
